import { memo } from 'react';

import { Button } from 'antd';

import classnames from 'classnames';

import styles from './styles.module.scss';

const CancelSaveButtons = ({ disabled = false, loading = false, handleCancel, handleSave, handleSaveAndNavigate }) => {
  return (
    <div className={classnames('d-flex flex-nowrap gap-2 user-select-none', styles['buttons-container'])}>
      <Button className={styles['button-left']} size="large" onClick={handleCancel}>
        Cancel
      </Button>
      <Button
        className={handleSaveAndNavigate ? styles['button-middle'] : styles['button-right']}
        loading={loading}
        size="large"
        type="primary"
        disabled={disabled}
        onClick={handleSave}>
        Save
      </Button>
      {handleSaveAndNavigate && (
        <Button
          size="large"
          type="primary"
          className={styles['button-right']}
          disabled={disabled}
          loading={loading}
          onClick={handleSaveAndNavigate}>
          Save and add another
        </Button>
      )}
    </div>
  );
};

export default memo(CancelSaveButtons);
